/**
 * カテゴリ一覧
 */
export default {
  /**
   * カテゴリ一覧取得(特大カテゴリ指定)
   * @param {Number} type 特大カテゴリ
   * @returns {Array} カテゴリ一覧
   */
  getCategoryTypeList: function (type = 1) {
    const catList = this.getAll(),
      len = catList.length;
    let list = [];
    for (let i = 0; i < len; i++) {
      const cat = catList[i];
      if (cat.catType === type) {
        list.push(cat);
      } else if (cat.catType) {
        // 他のカテゴリ
        continue;
      } else {
        // 未指定
        const childLen = cat.list.length;
        let midList = [];
        for (let j = 0; j < childLen; j++) {
          const mitCat = cat.list[j];
          if (mitCat.catType === type) {
            midList.push(midList);
          }
        }

        if (midList.length > 0) {
          list.push({
            catExlCd: cat.catExlCd,
            catExlNm: cat.catExlNm,
            catLrgCd: cat.catLrgCd,
            catLrgNm: cat.catLrgNm,
            iconType: cat.iconType,
            list: midList
          });
        }
      }
    }
    return list;
  },
  /**
   * カテゴリ全取得
   * @returns {Array} カテゴリ一覧
   */
  getAll: function () {
    return this.CATEGORY;
  },
  CATEGORY: [
    {
      catExlCd: "leisure",
      catExlNm: "遊ぶ",
      catLrgCd: "102",
      catLrgNm: "レジャー",
      catType: 1,
      list: [
        {
          catLrgCd: "103",
          catMidCd: "201",
          catMidNm: "映画",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "映画館"
            },
            {
              catSmlCd: "302",
              catSmNm: "映画作品券"
            }
          ]
        },
        {
          catLrgCd: "103",
          catMidCd: "203",
          catMidNm: "公演・観戦チケット",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "スポーツ観戦チケット"
            },
            {
              catSmlCd: "302",
              catSmNm: "演劇・舞台"
            },
            {
              catSmlCd: "303",
              catSmNm: "コンサート"
            },
            {
              catSmlCd: "304",
              catSmNm: "その他チケット"
            }
          ]
        },
        {
          catMidCd: "201",
          catMidNm: "遊園地・テーマパーク"
        },
        {
          catMidCd: "202",
          catMidNm: "美術館・博物館・アート"
        },
        {
          catMidCd: "203",
          catMidNm: "果物・味覚狩り"
        },
        {
          catMidCd: "204",
          catMidNm: "キッズ向け"
        },
        {
          catMidCd: "205",
          catMidNm: "アウトドアレジャー",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "アウトドアレジャー"
            },
            {
              catSmlCd: "302",
              catSmNm: "ウィンタースポーツ"
            },
            {
              catSmlCd: "303",
              catSmNm: "マリンスポーツ"
            }
          ]
        },
        {
          catMidCd: "206",
          catMidNm: "その他レジャー施設"
        },
        {
          catLrgCd: "103",
          catMidCd: "202",
          catMidNm: "アミューズメント",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ボウリング"
            },
            {
              catSmlCd: "302",
              catSmNm: "カラオケ"
            },
            {
              catSmlCd: "303",
              catSmNm: "インターネットカフェ"
            }
          ]
        },
        {
          catLrgCd: "103",
          catMidCd: "204",
          catMidNm: "動画・音楽配信"
        },
        {
          catLrgCd: "103",
          catMidCd: "205",
          catMidNm: "その他エンタメ"
        }
      ]
    },
    {
      catExlCd: "gourmet",
      catExlNm: "食べる",
      catLrgCd: "113",
      catLrgNm: "グルメ",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "飲食店",
          catType: 2,
          list: [
            {
              catSmlCd: "301",
              catSmNm: "居酒屋",
              catType: 2,
            },
            {
              catSmlCd: "302",
              catSmNm: "ダイニングバー",
              catType: 2,
            },
            {
              catSmlCd: "303",
              catSmNm: "ＢＡＲ・ビアガーデン",
              catType: 2,
            },
            {
              catSmlCd: "304",
              catSmNm: "和食",
              catType: 2,
            },
            {
              catSmlCd: "305",
              catSmNm: "焼肉・ホルモン",
              catType: 2,
            },
            {
              catSmlCd: "306",
              catSmNm: "ステーキ・グリル料理",
              catType: 2,
            },
            {
              catSmlCd: "307",
              catSmNm: "すき焼き・しゃぶしゃぶ",
              catType: 2,
            },
            {
              catSmlCd: "308",
              catSmNm: "懐石・会席料理",
              catType: 2,
            },
            {
              catSmlCd: "309",
              catSmNm: "割烹・小料理",
              catType: 2,
            },
            {
              catSmlCd: "310",
              catSmNm: "魚介・海鮮料理",
              catType: 2,
            },
            {
              catSmlCd: "311",
              catSmNm: "寿司",
              catType: 2,
            },
            {
              catSmlCd: "312",
              catSmNm: "天ぷら",
              catType: 2,
            },
            {
              catSmlCd: "313",
              catSmNm: "鍋",
              catType: 2,
            },
            {
              catSmlCd: "314",
              catSmNm: "そば・うどん",
              catType: 2,
            },
            {
              catSmlCd: "315",
              catSmNm: "丼もの",
              catType: 2,
            },
            {
              catSmlCd: "316",
              catSmNm: "定食・食堂",
              catType: 2,
            },
            {
              catSmlCd: "317",
              catSmNm: "軽食",
              catType: 2,
            },
            {
              catSmlCd: "318",
              catSmNm: "洋食",
              catType: 2,
            },
            {
              catSmlCd: "319",
              catSmNm: "カレー",
              catType: 2,
            },
            {
              catSmlCd: "320",
              catSmNm: "ピザ",
              catType: 2,
            },
            {
              catSmlCd: "321",
              catSmNm: "イタリア料理",
              catType: 2,
            },
            {
              catSmlCd: "322",
              catSmNm: "フランス料理",
              catType: 2,
            },
            {
              catSmlCd: "323",
              catSmNm: "中国料理",
              catType: 2,
            },
            {
              catSmlCd: "324",
              catSmNm: "韓国料理",
              catType: 2,
            },
            {
              catSmlCd: "325",
              catSmNm: "アジア・エスニック",
              catType: 2,
            },
            {
              catSmlCd: "326",
              catSmNm: "多国籍",
              catType: 2,
            },
            {
              catSmlCd: "327",
              catSmNm: "ブッフェ・バイキング",
              catType: 2,
            },
            {
              catSmlCd: "328",
              catSmNm: "ラーメン・つけ麺・ちゃんぽん",
              catType: 2,
            },
            {
              catSmlCd: "329",
              catSmNm: "自然・薬膳・野菜",
              catType: 2,
            },
            {
              catSmlCd: "330",
              catSmNm: "カフェ・スイーツ",
              catType: 2,
            },
            {
              catSmlCd: "331",
              catSmNm: "ファミレス・ファーストフード",
              catType: 2,
            },
            {
              catSmlCd: "332",
              catSmNm: "エンターテインメント",
              catType: 2,
            },
            {
              catSmlCd: "333",
              catSmNm: "その他飲食店",
              catType: 2,
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "予約サイト・食事券",
        }
      ]
    },
    {
      catExlCd: "care",
      catExlNm: "育児",
      catLrgCd: "109",
      catLrgNm: "育児",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "育児サービス",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "育児用品"
            },
            {
              catSmlCd: "302",
              catSmNm: "その他育児サービス"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "託児・ベビーシッター",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "育児施設・学童"
            },
            {
              catSmlCd: "302",
              catSmNm: "ベビーシッター"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "教育・セミナー",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "教育"
            },
            {
              catSmlCd: "302",
              catSmNm: "セミナー"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "shopping",
      catExlNm: "ショッピング",
      catLrgCd: "114",
      catLrgNm: "買い物",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "書籍・新聞",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "新聞"
            },
            {
              catSmlCd: "302",
              catSmNm: "書籍・雑誌"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "定期購読",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ビジネス誌"
            },
            {
              catSmlCd: "302",
              catSmNm: "一般誌"
            },
            {
              catSmlCd: "303",
              catSmNm: "スポーツ誌"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "オンラインショップ",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ファッション"
            },
            {
              catSmlCd: "302",
              catSmNm: "ビジネススーツ"
            },
            {
              catSmlCd: "303",
              catSmNm: "メガネ・コンタクト"
            },
            {
              catSmlCd: "304",
              catSmNm: "ブランド品"
            },
            {
              catSmlCd: "305",
              catSmNm: "スポーツ用品"
            },
            {
              catSmlCd: "306",
              catSmNm: "食料・飲料"
            },
            {
              catSmlCd: "307",
              catSmNm: "美容・コスメ"
            },
            {
              catSmlCd: "308",
              catSmNm: "家具・雑貨"
            },
            {
              catSmlCd: "309",
              catSmNm: "家電・ソフトウェア"
            },
            {
              catSmlCd: "310",
              catSmNm: "カー用品"
            },
            {
              catSmlCd: "311",
              catSmNm: "健康グッズ・食品"
            },
            {
              catSmlCd: "312",
              catSmNm: "オンラインサービス"
            },
            {
              catSmlCd: "313",
              catSmNm: "総合ECサイト"
            },
            {
              catSmlCd: "314",
              catSmNm: "その他オンラインショップ"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "店舗",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ファッション"
            },
            {
              catSmlCd: "302",
              catSmNm: "ビジネススーツ"
            },
            {
              catSmlCd: "303",
              catSmNm: "メガネ・コンタクト"
            },
            {
              catSmlCd: "304",
              catSmNm: "ブランド品"
            },
            {
              catSmlCd: "305",
              catSmNm: "スポーツ用品"
            },
            {
              catSmlCd: "306",
              catSmNm: "食品・飲料"
            },
            {
              catSmlCd: "307",
              catSmNm: "美容・コスメ"
            },
            {
              catSmlCd: "308",
              catSmNm: "家具・雑貨"
            },
            {
              catSmlCd: "309",
              catSmNm: "家電・ソフトウェア"
            },
            {
              catSmlCd: "310",
              catSmNm: "カー用品"
            },
            {
              catSmlCd: "311",
              catSmNm: "健康グッズ・食品"
            },
            {
              catSmlCd: "312",
              catSmNm: "ショッピングモール・デパート"
            },
            {
              catSmlCd: "313",
              catSmNm: "スーパー・ドラッグストア"
            },
            {
              catSmlCd: "314",
              catSmNm: "ホームセンター"
            },
            {
              catSmlCd: "315",
              catSmNm: "その他店舗"
            }
          ]
        },
        {
          catMidCd: "205",
          catMidNm: "ギフト",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "カタログギフト"
            },
            {
              catSmlCd: "302",
              catSmNm: "フラワーギフト"
            },
            {
              catSmlCd: "303",
              catSmNm: "商品券"
            },
            {
              catSmlCd: "304",
              catSmNm: "ギフトコード"
            },
            {
              catSmlCd: "305",
              catSmNm: "その他ギフト"
            }
          ]
        },
        {
          catMidCd: "206",
          catMidNm: "株主優待券"
        }
      ]
    },
    {
      catExlCd: "relaxation",
      catExlNm: "リラク・ビューティー",
      catLrgCd: "106",
      catLrgNm: "リラク",
      catType: 1,
      list: [
        {
          catLrgCd: "105",
          catMidCd: "201",
          catMidNm: "日帰り湯・サウナ・岩盤浴",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "日帰り湯"
            },
            {
              catSmlCd: "302",
              catSmNm: "サウナ・岩盤浴"
            }
          ]
        },
        {
          catMidCd: "201",
          catMidNm: "リラクサロン"
        },
        {
          catMidCd: "202",
          catMidNm: "エステ"
        },
        {
          catMidCd: "203",
          catMidNm: "ヘア・ネイル・アイサロン",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ヘアサロン"
            },
            {
              catSmlCd: "302",
              catSmNm: "ヘアケア"
            },
            {
              catSmlCd: "303",
              catSmNm: "ネイルサロン"
            },
            {
              catSmlCd: "304",
              catSmNm: "アイサロン"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "予約サイト"
        },
        {
          catMidCd: "205",
          catMidNm: "その他リラク・ビューティー"
        }
      ]
    },
    {
      catExlCd: "sports",
      catExlNm: "スポーツ",
      catLrgCd: "104",
      catLrgNm: "スポーツ",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "フィットネス",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "スポーツクラブ・ジム・トレーニング"
            },
            {
              catSmlCd: "302",
              catSmNm: "ヨガ・ピラティス"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "ゴルフ",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ゴルフ場"
            },
            {
              catSmlCd: "302",
              catSmNm: "ゴルフスクール"
            },
            {
              catSmlCd: "303",
              catSmNm: "ゴルフ練習場"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "テニス",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "テニス場"
            },
            {
              catSmlCd: "302",
              catSmNm: "テニススクール"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "サッカー・フットサル"
        },
        {
          catMidCd: "205",
          catMidNm: "ボルダリング・クライミング"
        },
        {
          catMidCd: "206",
          catMidNm: "その他スポーツ"
        }
      ]
    },
    {
      catExlCd: "travel",
      catExlNm: "トラベル",
      catLrgCd: "101",
      catLrgNm: "旅行",
      catType: 3,
      list: [
        {
          catMidCd: "201",
          catMidNm: "国内の宿",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ホテル",
              searchParam: "numPeople=2&adultHeadCnt=2&feeLower=0&feeUpper=0&facility=isBusinessHotel,isCityHotel,isResortHotel&roomType=&mealCondition=&roomCondition=&serviceEquip=&usageMethod=&planByCompany=isNotRakuten&checkInDate=&checkOutDate=&keyword=&orderBy=LOWEST_PRICE&stayNights=1&category=stay&exUpperGradesHeadCnt=0&exLowerGradesHeadCnt=0&youjiAHeadCnt=0&youjiBHeadCnt=0&youjiCHeadCnt=0&youjiDHeadCnt=0&roomCnt=1&rooms=1"
            },
            {
              catSmlCd: "302",
              catSmNm: "旅館",
              searchParam: "numPeople=2&adultHeadCnt=2&feeLower=0&feeUpper=0&facility=isRyokan&roomType=&mealCondition=&roomCondition=&serviceEquip=&usageMethod=&planByCompany=isNotRakuten&checkInDate=&checkOutDate=&keyword=&orderBy=LOWEST_PRICE&stayNights=1&category=stay&exUpperGradesHeadCnt=0&exLowerGradesHeadCnt=0&youjiAHeadCnt=0&youjiBHeadCnt=0&youjiCHeadCnt=0&youjiDHeadCnt=0&roomCnt=1&rooms=1"
            },
            {
              catSmlCd: "305",
              catSmNm: "おもてなしの宿",
              searchParam: "numPeople=2&adultHeadCnt=2&feeLower=0&feeUpper=0&facility=&roomType=&mealCondition=&roomCondition=&serviceEquip=&usageMethod=&planByCompany=&checkInDate=&checkOutDate=&keyword=直営%E3%80%80おもてなしの宿&orderBy=LOWEST_PRICE&stayNights=1&category=stay&exUpperGradesHeadCnt=0&exLowerGradesHeadCnt=0&youjiAHeadCnt=0&youjiBHeadCnt=0&youjiCHeadCnt=0&youjiDHeadCnt=0&roomCnt=1&rooms=1"
            },
            {
              catSmlCd: "310",
              catSmNm: "その他国内の宿",
              searchParam: "numPeople=2&adultHeadCnt=2&feeLower=0&feeUpper=0&facility=isTownist,isGamping,isVillaCondominium,isCortage,isPension,isGuestHouseHostelDormitory,isCapsuleHotel,isApartment,isGuestroom,isCornerStay&roomType=&mealCondition=&roomCondition=&serviceEquip=&usageMethod=&planByCompany=isNotRakuten&checkInDate=&checkOutDate=&keyword=&orderBy=LOWEST_PRICE&stayNights=1&category=stay&exUpperGradesHeadCnt=0&exLowerGradesHeadCnt=0&youjiAHeadCnt=0&youjiBHeadCnt=0&youjiCHeadCnt=0&youjiDHeadCnt=0&roomCnt=1&rooms=1"
            }
          ]
        },
        {
          catMidCd: "206",
          catMidNm: "航空券・交通",
          catType: 3
        },
        {
          catMidCd: "207",
          catMidNm: "その他旅行関連",
          catSmlCd: "301",
          catType: 3
        },
        {
          catMidCd: "201",
          catMidNm: "国内宿泊予約サイト",
          catSmlCd: "311",
          catType: 4
        },
        {
          catMidCd: "204",
          catMidNm: "海外宿泊予約サイト",
          catSmlCd: "301",
          catType: 4
        }
      ]
    },
    {
      catExlCd: "car",
      catExlNm: "車",
      catLrgCd: "108",
      catLrgNm: "カー",
      catType: 1,
      list: [
        {
          catMidCd: "203",
          catSmlCd: "301",
          catSmNm: "レンタカー"
        },
        {
          catMidCd: "203",
          catSmlCd: "302",
          catSmNm: "カーシェア・カーリース"
        },
        {
          catMidCd: "203",
          catSmlCd: "303",
          catSmNm: "駐車場"
        },
        {
          catMidCd: "203",
          catSmlCd: "304",
          catSmNm: "ガソリンスタンド"
        },
        {
          catMidCd: "203",
          catSmlCd: "305",
          catSmNm: "新車・中古車販売・買取"
        },
        {
          catMidCd: "203",
          catSmlCd: "306",
          catSmNm: "タクシー・送迎サービス"
        },
        {
          catMidCd: "203",
          catSmlCd: "307",
          catSmNm: "免許・教習所"
        },
        {
          catMidCd: "203",
          catSmlCd: "308",
          catSmNm: "車検・修理・整備"
        },
        {
          catMidCd: "203",
          catSmlCd: "309",
          catSmNm: "その他カー"
        }
      ]
    },
    {
      catExlCd: "original",
      catExlNm: "オリジナル企画",
      catLrgCd: "116",
      catLrgNm: "オリジナル",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "慶事お祝い",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "結婚・出産"
            },
            {
              catSmlCd: "302",
              catSmNm: "仕事・スキル"
            },
            {
              catSmlCd: "303",
              catSmNm: "お子様"
            },
            {
              catSmlCd: "304",
              catSmNm: "ライフイベント"
            },
            {
              catSmlCd: "305",
              catSmNm: "その他慶事お祝い"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "キャンペーン",
        },
        {
          catMidCd: "203",
          catMidNm: "イベント・セミナー"
        },
        {
          catMidCd: "204",
          catMidNm: "オリジナルコンテンツ",
        },
        {
          catMidCd: "205",
          catMidNm: "その他オリジナル企画"
        }
      ]
    },
    {
      catExlCd: "skill",
      catExlNm: "勉学",
      catLrgCd: "107",
      catLrgNm: "学ぶ",
      catType: 1,
      list: [
        {
          catMidCd: "205",
          catMidNm: "IT・パソコン"
        },
        {
          catMidCd: "204",
          catMidNm: "ビジネススキル"
        },
        {
          catMidCd: "202",
          catMidNm: "資格取得",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "スクール"
            },
            {
              catSmlCd: "302",
              catSmNm: "オンライン・教材・通信講座"
            },
            {
              catSmlCd: "303",
              catSmNm: "検定"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "趣味・教養"
        },
        {
          catMidCd: "206",
          catMidNm: "スキルアップ企画・制度"
        },
        {
          catMidCd: "201",
          catMidNm: "語学",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "スクール"
            },
            {
              catSmlCd: "302",
              catSmNm: "教材・通信講座"
            },
            {
              catSmlCd: "303",
              catSmNm: "オンライン"
            },
            {
              catSmlCd: "304",
              catSmNm: "留学・その他"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "life",
      catExlNm: "暮らす",
      catLrgCd: "108",
      catLrgNm: "ライフ",
      catType: 1,
      list: [
        {
          catMidCd: "202",
          catMidNm: "住まい",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "住宅購入"
            },
            {
              catSmlCd: "302",
              catSmNm: "賃貸住宅"
            },
            {
              catSmlCd: "303",
              catSmNm: "リフォーム・メンテナンス"
            },
            {
              catSmlCd: "304",
              catSmNm: "ガーデニング"
            },
            {
              catSmlCd: "305",
              catSmNm: "防犯・防災"
            },
            {
              catSmlCd: "306",
              catSmNm: "住宅関連セミナー"
            }
          ]
        },
        {
          catMidCd: "209",
          catMidNm: "写真・プリント"
        },
        {
          catMidCd: "201",
          catMidNm: "家事・ハウスクリーニング",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "家事代行・ハウスクリーニング"
            },
            {
              catSmlCd: "302",
              catSmNm: "クリーニング・お直し"
            }
          ]
        },
        {
          catMidCd: "211",
          catMidNm: "相談・サポート",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "相談サービス"
            },
            {
              catSmlCd: "302",
              catSmNm: "トラブルサポート"
            }
          ]
        },
        {
          catMidCd: "206",
          catMidNm: "リサイクル・レンタル",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "リサイクル"
            },
            {
              catSmlCd: "302",
              catSmNm: "レンタルサービス"
            },
            {
              catSmlCd: "303",
              catSmNm: "買取"
            }
          ]
        },
        {
          catMidCd: "207",
          catMidNm: "ライフプラン設計",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "保険・金融・資産形成"
            },
            {
              catSmlCd: "302",
              catSmNm: "ふるさと納税"
            },
            {
              catSmlCd: "303",
              catSmNm: "終活"
            },
            {
              catSmlCd: "304",
              catSmNm: "その他ライフプラン設計"
            }
          ]
        },
        {
          catMidCd: "212",
          catMidNm: "葬儀・葬祭"
        },
        {
          catMidCd: "205",
          catMidNm: "引越し"
        },
        {
          catMidCd: "208",
          catMidNm: "ペット"
        },
        {
          catLrgCd: "112",
          catMidCd: "202",
          catMidNm: "ブライダル",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "結婚式"
            },
            {
              catSmlCd: "302",
              catSmNm: "リング"
            },
            {
              catSmlCd: "303",
              catSmNm: "ドレス"
            },
            {
              catSmlCd: "304",
              catSmNm: "ブライダルエステ"
            },
            {
              catSmlCd: "305",
              catSmNm: "その他ブライダル"
            }
          ]
        },
        {
          catLrgCd: "112",
          catMidCd: "201",
          catMidNm: "出会い",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "結婚情報"
            },
            {
              catSmlCd: "302",
              catSmNm: "お見合いパーティ"
            },
            {
              catSmlCd: "303",
              catSmNm: "ネット婚活"
            },
            {
              catSmlCd: "304",
              catSmNm: "その他出会い"
            }
          ]
        },
        {
          catLrgCd: "110",
          catMidCd: "201",
          catMidNm: "介護",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "在宅介護"
            },
            {
              catSmlCd: "302",
              catSmNm: "シニア住宅・介護施設"
            },
            {
              catSmlCd: "303",
              catSmNm: "介護用品"
            },
            {
              catSmlCd: "304",
              catSmNm: "見守りサービス"
            },
            {
              catSmlCd: "305",
              catSmNm: "介護タクシー"
            },
            {
              catSmlCd: "306",
              catSmNm: "宅配・宅食"
            },
            {
              catSmlCd: "307",
              catSmNm: "その他介護"
            }
          ]
        },
        {
          catLrgCd: "111",
          catMidCd: "201",
          catMidNm: "健康管理",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "眼科"
            },
            {
              catSmlCd: "302",
              catSmNm: "歯科"
            },
            {
              catSmlCd: "303",
              catSmNm: "美容医療"
            },
            {
              catSmlCd: "304",
              catSmNm: "その他健康管理"
            }
          ]
        },
        {
          catLrgCd: "111",
          catMidCd: "202",
          catMidNm: "健診・相談",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "健診・郵送検診"
            },
            {
              catSmlCd: "302",
              catSmNm: "相談・カウンセリング"
            }
          ]
        },
        {
          catLrgCd: "117",
          catMidCd: "201",
          catMidNm: "ポイント交換",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "募金"
            },
            {
              catSmlCd: "302",
              catSmNm: "提携サイト"
            }
          ]
        }
      ]
    }
  ]
};
